export default "__VITE_ASSET__7939960f__"